import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { reducer as formReducer } from 'redux-form'
import { toastsReducer as toastReducer } from 'react-toastify-redux'
import { reducer as appReducer } from 'store/ducks/app'
import { reducer as authenticationReducer, epic as authenticationEpic } from 'store/ducks/authentication'
import { reducer as securityReducer } from 'store/ducks/security'
import { reducer as registerReducer, epic as registerEpic } from 'store/ducks/register'
import { reducer as recoverReducer, epic as recoverEpic } from 'store/ducks/recover'
import { reducer as intlReducer } from 'store/ducks/intl'
import { reducer as adminUserValidateReducer, epic as adminUserValidateEpic } from 'store/ducks/admin/userValidate'
import { reducer as vouchersReducer, epic as vouchersEpic } from 'store/ducks/vouchers'
import { reducer as profileReducer, epic as profileEpic } from 'store/ducks/profile'
import { reducer as deliveryReducer, epic as deliveryEpic } from 'store/ducks/delivery'
import { reducer as vehicleReducer, epic as vehicleEpic } from 'store/ducks/vehicle'
import { reducer as companyReducer, epic as companyEpic } from 'store/ducks/company'
import { reducer as courierReducer, epic as courierEpic } from 'store/ducks/courier'
import { reducer as couriersReducer, epic as couriersEpic } from 'store/ducks/couriers'
import { reducer as messengerReducer, epic as messengerEpic } from 'store/ducks/messaging'
import { reducer as operationsReducer, epic as operationsEpic } from 'store/ducks/operations'
import rideReducer, { epic as rideEpic } from 'store/ducks/ride'
import { reducer as deliveryRidesReducer, epic as deliveryRidesEpic } from 'store/ducks/deliveryRides'
import {
  reducer as deliveryEmptyReturnsReducer,
  epic as deliveryEmptyReturnsEpic,
} from 'store/ducks/deliveryEmptyReturns'
import { reducer as notificationsReducer, epic as notificationsEpic } from 'store/ducks/notifications'
import { reducer as favouriteReducer, epic as favouriteEpic } from 'store/ducks/favourite'
import { reducer as favouritesReducer, epic as favouritesEpic } from 'store/ducks/favourites'
import { reducer as deliveryFavouriteReducer, epic as deliveryFavouriteEpic } from 'store/ducks/deliveryFavourite'
import ridesReducer, { epic as ridesEpic } from 'store/ducks/rides'
import invoicingReducer, { epic as invoincingEpic } from 'store/ducks/invoicing'
import { epic as heartbeatEpic } from 'store/ducks/heartbeat'
import { reducer as customizeReducer, epic as customizeEpic } from 'store/ducks/customize'
import { reducer as customPageReducer, epic as customPageEpic } from 'store/ducks/custompages'
import { reducer as scenarioProposalsReducer, epic as scenarioProposalsEpic } from 'store/ducks/scenarioProposals'
import { reducer as hubsReducer, epic as hubsEpic } from 'store/ducks/hub'
import { reducer as logsReducer, epic as logsEpic } from 'store/ducks/logs'
import { reducer as profitabilityReducer, epic as profitabilityEpic } from 'store/ducks/profitability'
import { reducer as geolocationReducer, epic as geolocationEpic } from 'store/ducks/geolocation'
import { reducer as hoursReducer, epic as hoursEpic } from 'store/ducks/hours'
import { reducer as landingPageReducer, epic as landingPageEpic } from 'store/ducks/landingPage'
import { companyListener } from './company'
import { rideListener } from './ride'

export const reducer = combineReducers({
  toasts: toastReducer,
  app: appReducer,
  authentication: authenticationReducer,
  security: securityReducer,
  register: registerReducer,
  recover: recoverReducer,
  form: formReducer,
  intl: intlReducer,
  adminUserValidate: adminUserValidateReducer,
  vouchers: vouchersReducer,
  profile: profileReducer,
  delivery: deliveryReducer,
  vehicle: vehicleReducer,
  company: companyReducer,
  courier: courierReducer,
  couriers: couriersReducer,
  messenger: messengerReducer,
  operations: operationsReducer,
  ride: rideReducer,
  rides: ridesReducer,
  deliveryRides: deliveryRidesReducer,
  deliveryEmptyReturns: deliveryEmptyReturnsReducer,
  notifications: notificationsReducer,
  favourite: favouriteReducer,
  favourites: favouritesReducer,
  deliveryFavourite: deliveryFavouriteReducer,
  customPage: customPageReducer,
  customize: customizeReducer,
  invoicing: invoicingReducer,
  scenarioProposals: scenarioProposalsReducer,
  hubs: hubsReducer,
  logs: logsReducer,
  profitability: profitabilityReducer,
  geolocation: geolocationReducer,
  hours: hoursReducer,
  landingPage: landingPageReducer,
})

export const epic = combineEpics(
  authenticationEpic,
  registerEpic,
  recoverEpic,
  profileEpic,
  vouchersEpic,
  adminUserValidateEpic,
  deliveryEpic,
  vehicleEpic,
  companyEpic,
  courierEpic,
  couriersEpic,
  messengerEpic,
  heartbeatEpic,
  operationsEpic,
  rideEpic,
  ridesEpic,
  deliveryRidesEpic,
  deliveryEmptyReturnsEpic,
  notificationsEpic,
  favouriteEpic,
  favouritesEpic,
  deliveryFavouriteEpic,
  customizeEpic,
  customPageEpic,
  invoincingEpic,
  scenarioProposalsEpic,
  hubsEpic,
  logsEpic,
  profitabilityEpic,
  geolocationEpic,
  hoursEpic,
  landingPageEpic,
)

export const middlewares = [companyListener.middleware, rideListener.middleware]
